export default __webpack_public_path__ + "static/media/logo_sq.16f2b52f.png";